import React, { useMemo, useContext } from "react";
import PropTypes from "prop-types";
import ButtonBar from "../ButtonBar";
import CountyOverview from "./CountyOverview";
import CountyJudges from "./CountyJudges";
import { DataContext } from "../../context/DataContext";
import { COUNTY_BUTTON_SCHEMA } from "../../utils/constants";

const changeDisplay = ({
  year,
  countyDisplay,
  county,
  changeSelection,
  judgesInCounty,
  selectedCountyData,
}) => {
  const ENUM = {
    overview: (
      <CountyOverview
        countyData={selectedCountyData}
        judgesData={judgesInCounty}
        year={year}
      />
    ),
    judges: (
      <CountyJudges
        county={county}
        changeSelection={changeSelection}
        judgesData={judgesInCounty}
      />
    ),
  };
  return ENUM[countyDisplay];
};

const County = ({ countyDisplay, setCountyDisplay }) => {
  const {
    judgesData,
    countyData,
    changeSelection,
    selection,
    year,
  } = useContext(DataContext);
  const { county } = selection;
  const judgesInCounty = useMemo(() => {
    return judgesData.filter((item) => {
      return item.county === county;
    });
  }, [county, judgesData]);
  const selectedCountyData = useMemo(() => {
    return countyData.find((item) => item.id === county);
  }, [county, countyData]);

  return (
    <div className="panel__county">
      <ButtonBar
        schema={COUNTY_BUTTON_SCHEMA}
        active={countyDisplay}
        handleClick={setCountyDisplay}
      />
      {changeDisplay({
        year,
        countyDisplay,
        county,
        changeSelection,
        judgesInCounty,
        selectedCountyData,
      })}
    </div>
  );
};

County.propTypes = {
  countyDisplay: PropTypes.string.isRequired,
  setCountyDisplay: PropTypes.func.isRequired,
};

export default County;
